import React from 'react';
import { SecureUserHtml } from '@wix/wix-emails-secure-components';
import { Text } from '../../components/text';
export var ItemDescription = function (_a) {
    var _b;
    var section = _a.section, item = _a.item;
    if (((_b = section.show) === null || _b === void 0 ? void 0 : _b.description) === false) {
        return null;
    }
    return (React.createElement(Text, { align: section.description.align, color: section.description.color, fontFamily: section.description.fontFamily, fontSize: section.description.fontSize, fontStyle: section.description.fontStyle, fontWeight: section.description.fontWeight || undefined, lineHeight: section.description.lineHeight, textDecoration: section.description.textDecoration, padding: "0px" },
        React.createElement(SecureUserHtml, { html: item.description })));
};
//# sourceMappingURL=item-description.js.map